import React, {FC} from 'react';

import {useAppQuery} from '../../../../libs/shared/core/src/services/query/useAppQuery';
import {useAppSelector} from '../../../helpers/appReduxHelpers';
import {onboardingChatQueries} from '../../../queries/onboardingChatQueries';
import {getIsCustomer} from '../../../store/data/company/companySelectors';
import {getOnboardingChatPreferences} from '../../../store/data/preferences/preferencesSelectors';
import {FrontChat} from '../../app/frontChat/frontChat';

/*
 * Props.
 */

interface OnboardingChatProps {}

/*
 * Component.
 */

export const OnboardingChat: FC<OnboardingChatProps> = (props) => {
  const onboardingChatPreferences = useAppSelector(getOnboardingChatPreferences);
  const isCustomer = useAppSelector(getIsCustomer);
  const isEnabled = !isCustomer && Boolean(onboardingChatPreferences);
  const {data: config} = useAppQuery({
    ...onboardingChatQueries.config(),
    enabled: isEnabled,
  });

  if (!isEnabled || !config) {
    return null;
  }

  return (
    <FrontChat
      chatId={config.chatId}
      userEmail={config.email}
      userHash={config.userHash}
      bundleSrc={config.bundleSrc}
    />
  );
};
